<prizm-scroll-controls [style.visibility]="(showScrollbars$ | async) ? '' : 'hidden'"></prizm-scroll-controls>
<div class="content">
  <ng-content></ng-content>
</div>
